import axios from '@vtblife/axios';
class GeoApiService {
    constructor(name = 'root') {
        this.transport = axios.create({
            baseURL: `/api/${name}-bff/`,
        });
    }
    async getGeoSuggest(text, cancelToken) {
        return this.transport.get('/api/get-geo-suggest', { params: { text }, cancelToken });
    }
    async getGeoObjectByIdV2(regionId, cancelToken) {
        return this.transport.get('/api/get-geo-object-by-id-v2', { params: { regionId }, cancelToken });
    }
}
const geoApiService = new GeoApiService();
export { geoApiService };
//# sourceMappingURL=geo-api.js.map